import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getSelectedDocsSchedule, getStoreLocalData, getUserData, setSelectedDocsSchedule } from "../../utils/localStorage";
import { storeCustomerGetInfo } from "../../services/CustomerInfo/CustomerInfo";
import {
  getCartDetail,
  getCartDetailOffer,
  getCartDetailV2,
} from "../../services/Cart/cartDetail";
import { Checkbox } from "primereact/checkbox";
import { getCartPackage } from "../../services/Cart/getCartPackage";
import { clearCart } from "../../services/Cart/clearCart";
import { clearCartItem } from "../../services/Cart/clearCartItem";
import { Button } from "primereact/button";
import AdditionalInfo from "./AdditionalInfo";
import PaymentDetail from "./PaymentDetail";
import AdvancePaymentCollection from "./AdvancePaymentCollection";
import TotalPackageCountModal from "./TotalPackageCountModal";
import PackageSubscriptionOfferDefault from "./PackageSubscriptionOfferDefault";
import { setPackageSubscriptionOfferDefault } from "../../services/PaymentOfferManagement/CheckPackageSubscriptionOffer";
import { bookOrder, bookOrderB2BModal, getStoreLoad } from "../../services/Cart/BookNewOrder";
import SuccessModal from "../SuccessModal";
import OfferMessageModal from "./OfferMessageModal";
import {
  CartPackageCarryForwardApply,
  CustomerOrderPackageLog,
  markCarryForward,
} from "../../services/PackageLog/PackageLog";
import CustomerPackagesModal from "./CustomerPackagesModal";
import ChooseB2BModal from "./ChooseB2BModal";
import PackagePriceEditModal from "./PackagePriceEditModal";
import { getAllCustomerPackageOffer } from "../../services/CustomerPackageOffer/CustomerPackageOffer";
import SubscriptionMessageModal from "./SubscriptionMessageModal";
import { maskMobileNumber } from "../../constants/DateUtil/DateUtil";

const { innerWidth: width, innerHeight: height } = window;

const CartPage = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { storeCustomerId, BookingType } = location.state || {}; // Fallback to prevent undefined errors
  const {
    storeData,
    userProfileRole,
    userProfileData,
    brandProfileData,
    garmentCategoryServiceIconsResData,
  } = getUserData();
  const { storeLocalData } = getStoreLocalData();
  const storeId = storeData.id;
  const userRole = userProfileRole;
  const gstValue = storeData.gst;
  const storeGstNumber = storeData.gstNo;
  const storeGstType = storeData.gstType;
  const processTime = storeData.processTime;
  const storeUserId = userProfileData.id;
  const brandId = userProfileData.brandId;
  const offerDiscountByStore = storeData.offerDiscountByStore;
  const offerDiscountByRider = storeData.offerDiscountByRider;
  const enabledCustomDiscountCharge = storeData.enabledCustomDiscountCharge;
  const enabledChargeDiscountByService =
    storeData.enabledChargeDiscountByService;
  const enabledStoreLoad = storeData.enabledStoreLoad;
  const storeCarryForward = storeData.packageCarryForward;
  const storeAutoPackageCarryForward = storeData.autoPackageCarryForward;
  const brandCarryForward = brandProfileData.packageCarryForward;
  const brandCarryForwardApplyOn = brandProfileData.carryForwardApplyOn;
  const B2BModelBrand = brandProfileData.enabledB2BModel;
  const B2BModelStore = storeData.enabledB2BModel;
  const enabledGSTControl = storeData.enabledGSTControl;
  const offerPriceEnabled = storeData.offerPriceEnabled;
  const deliveryDateCutoffTime = storeData.deliveryDateCutoffTime;

  const enabledApplySubscriptionWithPackage = storeData.enabledApplySubscriptionWithPackage;
  const enabledAutoApplySubscriptionWithPackage = storeData.enabledAutoApplySubscriptionWithPackage;
  const blockCheckoutInPackageSubscriptionLowBalance = storeData.blockCheckoutInPackageSubscriptionLowBalance;
  const enabledAmountRoundOff = storeData.enabledAmountRoundOff ? 0 : 2;

  const [isCheckOutButtonPressed, setIsCheckOutButtonPressed] = useState(false);
  const [cartPackageData, setCartPackageData] = useState([]);

  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(false);
  const [cartItemOffers, setCartItemOffers] = useState({});
  const [cartItemDetails, setCartItemDetails] = useState([]);
  const [totalPriceSum, setTotalPriceSum] = useState(null);
  const [totalPackagePriceSum, setTotalPackagePriceSum] = useState(null);
  const [totalAmountSum, setTotalAmountSum] = useState(null);
  const [customerData, setCustomerData] = useState({});
  const [customerPackagesModalVisible, setCustomerPackagesModalVisible] = useState(false)
  const [chooseB2BModelVisible, setChooseB2BModelVisible] = useState(false)

  const [docsScheduleValue, setDocsScheduleValue] = useState("");
  const [b2BModelSelected, setB2BModelSelected] = useState(false)

  const fetchDocsSchedule = async () => {
    try {
      const docsSchedule = await getSelectedDocsSchedule();
      setDocsScheduleValue(docsSchedule.docsSchedule);
    } catch {
      setDocsScheduleValue("yes");
    }
  };

  // package amount
  const [updatedPackagePriceSum, setUpdatedPackagePriceSum] = useState(0);

  const [markCarryForwardPackage, setMarkCarryForwardPackage] = useState([]);
  const [customerOrderPackageLogAllData, setCustomerOrderPackageLogAllData] =
    useState([]);
  const [selectedCarryForwardCount, setSelectedCarryForwardCount] = useState(
    []
  );

  const [selectedItems, setSelectedItems] = useState({});
  const [collectAdvancePaymentCheck, setCollectAdvancePaymentCheck] =
    useState(false);

  const [
    checkedPackageSubscriptionOfferId,
    setCheckedPackageSubscriptionOfferId,
  ] = useState(null);

  const [
    checkedPackageSubscriptionOfferValue,
    setCheckedPackageSubscriptionOfferValue,
  ] = useState(null);

  const [messageDisplay, setMessageDisplay] = useState(false);
  const [messageText, setMessageText] = useState("");

  const [subscriptionMessageDisplay, setSubscriptionMessageDisplay] = useState(false);
  const [subscriptionMessageText, setSubscriptionMessageText] = useState("");
  const [subscriptionCanNotApply, setSubscriptionCanNotApply] = useState(false)

  const fetchCartDetail = async () => {
    try {
      const response = await getCartDetailV2(storeCustomerId, storeId);
      if (!response.data.error) {
        const cartRes = response.data;
        setCartItemDetails(cartRes);
        setTotalPriceSum(
          cartRes.reduce((total, item) => total + item.garmentTotalPrice, 0)
        );
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchCartDetailOffer = async () => {
    try {
      const response = await getCartDetailOffer(storeCustomerId, storeId);
      if (!response.data.error) {
        const cartOfferRes = response.data;
        setCartItemOffers(cartOfferRes.cartAddOnOfferMapList);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchStoreCustomerInfo = async () => {
    try {
      const response = await storeCustomerGetInfo(storeCustomerId, storeId);
      if (!response.data.error) {
        const Res = response.data;
        setCustomerData(Res);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchCartPackage = async () => {
    try {
      const response = await getCartPackage(storeCustomerId, storeId);
      if (!response.data.error) {
        const cartPackage = response.data;
        const modifiedPackageResponse = cartPackage.map((item, index) => ({
          ...item,
        }));
        const onlyCarryForward = cartPackage
          .filter((item, index) => item.packageDTO.carryForward === true)
          .map((item) => item.id);
        // setMarkCarryForwardPackage(onlyCarryForward);
        const packageLogData = {
          storeIds: [storeId],
          brandId: brandId,
          sortOrder: "desc",
          sortBy: "id",
          leftCarryForward: true,
          statusIn:
            brandCarryForwardApplyOn === "running"
              ? [
                "BOOKED",
                "INPROCESS",
                "PROCESSED",
                "IN_WAREHOUSE",
                "OUT_FOR_DELIVERY",
                "DONE",
                "DELIVERED",
              ]
              : ["DONE", "DELIVERED"], // add
          packageIdIn: cartPackage.map((item) => item.packageDTO.id),
          storeCustomerId: storeCustomerId,
          valid: true,
        };
        fetchPackageLogAllData(packageLogData);
        setCartPackageData(modifiedPackageResponse);
        const totalPackagePriceSum = cartPackage.reduce(
          (total, item) => total + item.totalPrice,
          0
        );

        setTotalPackagePriceSum(totalPackagePriceSum);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchPackageLogAllData = (data) => {
    CustomerOrderPackageLog({
      ...data,
      limit: 10,
      offset: 0,
    })
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerOrderPackageLogAllData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchCartDetail();
    fetchDocsSchedule();
    fetchStoreCustomerInfo();
    fetchCartPackage();

    if (userRole === "BY_STORE" && offerDiscountByStore) {
      fetchCartDetailOffer();
    } else {
      console.error("no Offer available");
    }
  }, []);

  useEffect(() => {
    if (!B2BModelBrand || !B2BModelStore) return

    if (cartPackageData?.length > 0 && cartItemDetails?.length === 0) {
      setChooseB2BModelVisible(false)
    } else if (cartPackageData?.length > 0 && cartItemDetails?.length > 0) {
      setChooseB2BModelVisible(false)
    } else if (cartPackageData?.length === 0 && cartItemDetails?.length > 0) {
      setChooseB2BModelVisible(true)
    }
  }, [B2BModelBrand, B2BModelStore, cartPackageData, cartItemDetails])




  const handleAdvancePaymentSubmit = ({
    storeUserId,
    storeCustomerId,
    receiveAmountValue,
    paymentMethodValue,
    receiveAmountError,
    paymentError,
  }) => {
    if (receiveAmountValue !== receiveAmount) {
      setReceiveAmount(receiveAmountValue);
    }
    if (paymentMethodValue !== paymentMethod) {
      setPaymentMethod(paymentMethodValue);
    }
    if (receiveAmountError !== "" || paymentError !== "") {
      setCollectAdvancePaymentCheck(true);
    } else {
      setCollectAdvancePaymentCheck(false);
    }
  };

  const [
    removalChargeAndDiscountFunction,
    setRemovalChargeAndDiscountFunction,
  ] = useState(false);

  const handleRemoveFromCart = async (itemId, addOnId) => {
    try {
      const response = await clearCartItem(storeCustomerId, storeId, itemId);
      if (!response.data.error) {
        // Update the cart details and other data
        fetchCartDetail();
        fetchDocsSchedule();
        if (userRole === "BY_STORE" && offerDiscountByStore) {
          fetchCartDetailOffer();
        } else {
          console.error("no Offer available");
        }

        fetchStoreCustomerInfo();
        fetchCartPackage();

        // Remove associated offers
        // setSelectedItems(prevSelectedItems => {
        //   const updatedSelectedItems = {...prevSelectedItems};
        //   delete updatedSelectedItems[addOnId];
        //   return updatedSelectedItems;
        // });
        setSelectedItems((prevSelectedItems) => {
          const updatedSelectedItems = { ...prevSelectedItems };
          addOnId.forEach((Id) => {
            delete updatedSelectedItems[Id];
          });
          return updatedSelectedItems;
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleRemoveAllItemFromCart = async () => {
    try {
      const response = await clearCart(storeCustomerId, storeId);
      if (!response.data.error) {
        const Res = response.data;
        fetchCartDetail();
        fetchDocsSchedule();
        if (userRole === "BY_STORE" && offerDiscountByStore) {
          fetchCartDetailOffer();
        } else {
          console.error("no Offer available");
        }

        fetchStoreCustomerInfo();
        fetchCartPackage();
        setRemovalChargeAndDiscountFunction(true);
      }
      setSelectedItems({});
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const offerDiscountSum = calculateSumOfferAmount(selectedItems);

  // useEffect(() => {
  //   setTotalAmountSum(totalPackagePriceSum + totalPriceSum);
  // }, [totalPackagePriceSum, totalPriceSum]);

  useEffect(() => {
    let newGst = (100 + gstValue) / 100; // (100 + 18 ) / 100

    const amount =
      storeGstType === "including"
        ? (totalPackagePriceSum + updatedPackagePriceSum + totalPriceSum) / newGst
        : totalPackagePriceSum + updatedPackagePriceSum + totalPriceSum;

    setTotalAmountSum(
      Number(amount?.toFixed(enabledAmountRoundOff))
    );

    // setTotalAmountSum(
    //   storeGstType === "including" ? parseFloat((totalPackagePriceSum + updatedPackagePriceSum + totalPriceSum) / newGst).toFixed(enabledAmountRoundOff) : parseFloat(totalPackagePriceSum + updatedPackagePriceSum + totalPriceSum).toFixed(enabledAmountRoundOff)
    // );
  }, [totalPackagePriceSum, updatedPackagePriceSum, totalPriceSum]);

  const CustomerInformation = {
    firstName: customerData?.brandCustomer?.firstName
      ? customerData?.brandCustomer?.firstName
      : "",
    lastName: customerData?.brandCustomer?.lastName
      ? customerData?.brandCustomer?.lastName
      : null,
    mobile: customerData?.brandCustomer?.mobile
      ? customerData?.brandCustomer?.mobile
      : "",
  };

  const transformedCartData = cartItemDetails.map((item, index) => ({
    garmentName: item.garmentName,
    categoryName: item.categoryName,
    garmentLogo: garmentCategoryServiceIconsResData?.iconMap[item.imageId],
    totalItemGarmentCount: item.totalItemGarmentCount,
    garmentTotalPrice: item.garmentTotalPrice,
    cartGarmentList: item.cartGarmentList.map((cartGarmentItem) => ({
      id: index + 1,
      itemId: cartGarmentItem.id,
      garmentAlias:
        cartGarmentItem.garmentAlias !== ""
          ? cartGarmentItem.garmentAlias + " | "
          : "",
      categoryName: cartGarmentItem.categoryName,
      price: cartGarmentItem.totalPrice,
      garmentCount: cartGarmentItem.itemGarmentCount,
      garmentLogo: cartGarmentItem.garmentLogo,
      addOnServiceName:
        cartGarmentItem.addOn.length > 0
          ? cartGarmentItem.addOn
            .map((addOnItem) => addOnItem.serviceName)
            .join(", ")
          : null,
      addOnServiceUnitName:
        cartGarmentItem.addOn.length > 0
          ? cartGarmentItem.addOn
            .map((addOnItem) => addOnItem.serviceUnit)
            .join(", ")
          : null,
      remarks: cartGarmentItem.remarks !== "" ? cartGarmentItem.remarks : "",
      count:
        cartGarmentItem.addOn.length > 0
          ? cartGarmentItem.addOn
            .map((addOnItem) => addOnItem.count + addOnItem.countGram)
            .join(", ")
          : null,
      offerPrice:
        cartGarmentItem.addOn.length > 0
          ? cartGarmentItem.addOn
            .map((addOnItem) => addOnItem.offerPrice)
            .join(", ")
          : null,
      addOn:
        cartGarmentItem.addOn.length > 0
          ? cartGarmentItem.addOn.map((addOnItem) => addOnItem)
          : null,
      addOnId:
        cartGarmentItem.addOn.length > 0
          ? cartGarmentItem.addOn.map((addOnItem) => addOnItem.id)
          : null,

      offerAddon:
        cartGarmentItem.addOn.length > 0 && cartGarmentItem.totalPrice > 0
          ? cartGarmentItem.addOn?.flatMap((addOnItem) =>
            (cartItemOffers[addOnItem.id] || []).map((offer) => ({
              // ...addOnItem,
              addOnServiceName: addOnItem.serviceName,
              addOnServiceTotalPrice: addOnItem.totalPrice,
              addOnItemId: addOnItem.id,
              isSelected: false,
              offerName: offer.brandOfferItemDTO.brandOffer.name,
              offerCount: offer.count,
              offer: offer,
              offerAmount: offer.offerAmount,
            }))
          )
          : [],
      bookingType: cartGarmentItem.bookingType,
    })),
  }));

  const uniqueServices = [
    ...new Set(
      cartItemDetails.flatMap((item) =>
        item.cartGarmentList.flatMap((item) =>
          item.addOn.map((addOnItem) => addOnItem.serviceName)
        )
      )
    ),
  ];

  // Function to calculate the sum of offerAmount
  function calculateSumOfferAmount(data) {
    let sum = 0;

    // Iterate over each itemId
    Object.keys(data).forEach((itemId) => {
      // Skip sumOfferAmount key
      if (itemId !== "sumOfferAmount") {
        // Iterate over each offer under the current itemId
        data[itemId].forEach((offer) => {
          sum += offer.offerAmount;
        });
      }
    });

    return sum;
  }

  const [additionalTotalChargesData, setAdditionalTotalChargesData] =
    useState(null);
  const [additionalChargesData, setAdditionalChargesData] = useState(null);
  const [additionalDiscountData, setAdditionalDiscountData] = useState(null);
  const [selectedChargesData, setSelectedChargesData] = useState([]);
  const [selectedDiscountData, setSelectedDiscountData] = useState([]);
  const [additionalInfoDeliveryDate, setAdditionalInfoDeliveryDate] =
    useState(null);
  const [additionalInfoIsCheckedGST, setAdditionalInfoIsCheckedGST] =
    useState(null);
  const [
    additionalInfoIsCheckedHomeDelivery,
    setAdditionalInfoIsCheckedHomeDelivery,
  ] = useState(null);
  const [
    additionalInfoIsCheckedUrgentDelivery,
    setAdditionalInfoIsCheckedUrgentDelivery,
  ] = useState(null);
  const [
    additionalInfoIsDocsScheduleValue,
    setAdditionalInfoIsDocsScheduleValue,
  ] = useState(null);
  const [additionalInfoOtherRemarkValue, setAdditionalInfoOtherRemarkValue] =
    useState(null);

  const receiveDataFromAdditionalInfo = ({
    totalCharges,
    additionalCharges,
    additionalDiscounts,
    selectedCharges,
    selectedDiscount,
    updatedCharges,
    updatedDiscounts,
    date,
    isCheckedGST,
    isCheckedHomeDelivery,
    isCheckedUrgentDelivery,
    isDocsScheduleValue,
    otherRemarkValue,
  }) => {
    // Check if the data has changed before calling setState
    if (totalCharges !== additionalTotalChargesData) {
      setAdditionalTotalChargesData(totalCharges);
    }
    if (additionalCharges !== additionalChargesData) {
      setAdditionalChargesData(additionalCharges);
    }
    if (additionalDiscounts !== additionalDiscountData) {
      setAdditionalDiscountData(additionalDiscounts);
    }
    if (date !== additionalInfoDeliveryDate) {
      setAdditionalInfoDeliveryDate(date);
    }
    if (isCheckedGST !== additionalInfoIsCheckedGST) {
      setAdditionalInfoIsCheckedGST(isCheckedGST);
    }
    if (isCheckedHomeDelivery !== additionalInfoIsCheckedHomeDelivery) {
      setAdditionalInfoIsCheckedHomeDelivery(isCheckedHomeDelivery);
    }
    if (isCheckedUrgentDelivery !== additionalInfoIsCheckedUrgentDelivery) {
      setAdditionalInfoIsCheckedUrgentDelivery(isCheckedUrgentDelivery);
    }
    if (isDocsScheduleValue !== additionalInfoIsDocsScheduleValue) {
      setAdditionalInfoIsDocsScheduleValue(isDocsScheduleValue);
    }
    if (otherRemarkValue !== additionalInfoOtherRemarkValue) {
      setAdditionalInfoOtherRemarkValue(otherRemarkValue);
    }

    // Check if the arrays are not empty before updating
    if (updatedCharges.length > 0 && updatedCharges !== selectedChargesData) {
      setSelectedChargesData(updatedCharges);
    }
    if (
      updatedDiscounts.length > 0 &&
      updatedDiscounts !== selectedDiscountData
    ) {
      setSelectedDiscountData(updatedDiscounts);
    }
  };

  const [blink, setBlink] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setBlink((prev) => !prev);
    }, 500); // Toggle every second

    return () => clearInterval(interval);
  }, []);

  const selectedChargesDiscount = [
    ...selectedChargesData,
    ...selectedDiscountData,
  ];

  let selectedChargesDiscountArray = selectedChargesDiscount.map((item) => {
    // Create a new object without the "id" property
    const { id, ...newObject } = item;
    return newObject;
  });

  let gst = gstValue === null ? 0 : gstValue / 100;

  const calculateTaxableAmount = () =>
    totalAmountSum +
    additionalTotalChargesData -
    (offerDiscountSum + checkedPackageSubscriptionOfferValue);

  const calculateAmountForSubscription = () =>
    totalAmountSum + additionalTotalChargesData - offerDiscountSum;

  const calculateOfferApplicableAmount = () =>
    totalAmountSum + additionalTotalChargesData;

  const offerApplicableAmount = calculateOfferApplicableAmount();

  const handleBackButton = () => {
    if (userRole === "BY_STORE") {
      navigate("/CustomerInfo", {
        state: {
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const handleSelectOffer = (itemId, offer) => {
    const offerKey = `${itemId}-${offer.offer.brandOfferItemDTO.id}`; // Use brandOfferItemDTO.id as the unique identifier

    setSelectedItems((prevSelectedItems) => {
      const itemOffers = prevSelectedItems[itemId] || [];
      const offerIndex = itemOffers.findIndex(
        (selectedOffer) =>
          selectedOffer.brandOfferItemDTO.id ===
          offer.offer.brandOfferItemDTO.id
      );

      // Calculate the current sum of offerAmount for all selected offers
      const currentOfferSum = Object.values(prevSelectedItems).reduce(
        (total, itemOffers) => {
          return (
            total +
            itemOffers.reduce(
              (itemTotal, offer) => itemTotal + offer.offerAmount,
              0
            )
          );
        },
        0
      );

      // If the offer is already selected, calculate the sum without including its amount
      let offerToRemoveAmount = 0;
      if (offerIndex > -1) {
        offerToRemoveAmount = itemOffers[offerIndex].offerAmount;
      }

      // Calculate the potential new sum if the offer were removed
      const newOfferSum = currentOfferSum - offerToRemoveAmount;

      // Calculate the sum of offerAmount for the same addOnServiceName
      const currentServiceOfferSum = itemOffers.reduce(
        (total, selectedOffer) => {
          if (selectedOffer.addOnServiceName === offer.addOnServiceName) {
            return total + selectedOffer.offerAmount;
          }
          return total;
        },
        0
      );

      if (offerIndex > -1) {
        // If offer is already selected, remove it by its index
        const updatedOffers = itemOffers.filter(
          (_, index) => index !== offerIndex
        );

        // If there are remaining offers for the item, update state with those offers
        if (updatedOffers.length > 0) {
          return { ...prevSelectedItems, [itemId]: updatedOffers };
        } else {
          // If no offers left for the item, remove the item from selected items
          const { [itemId]: omit, ...restSelectedItems } = prevSelectedItems;
          return restSelectedItems;
        }
      } else {
        // Otherwise, add it to selected items if it doesn't exceed totalAmountSum and addOnService total price
        const newServiceOfferSum = currentServiceOfferSum + offer.offerAmount;
        if (
          currentOfferSum + offer.offerAmount <= offerApplicableAmount &&
          newServiceOfferSum <= offer.addOnServiceTotalPrice
        ) {
          return {
            ...prevSelectedItems,
            [itemId]: [
              ...itemOffers,
              {
                brandOfferItemDTO: { id: offer.offer.brandOfferItemDTO.id },
                offerAmount: offer.offerAmount,
                count: offer.offer.count,
                addOnServiceName: offer.addOnServiceName,
              },
            ],
          };
        } else {
          setMessageDisplay(true);
          setMessageText(
            "Offer Value Can not be more than Garment Service Value"
          );
          // alert('Offer Value Can not be more than Garment Service Value');
          return prevSelectedItems; // Return current state without modifying
        }
      }
    });
  };

  const calculateSumOffersForItem = (item) => {
    if (!item?.cartGarmentList?.length) return 0;

    return item.cartGarmentList.reduce((total, cartGarmentItem) => {
      const offerAddons = cartGarmentItem.offerAddon || [];

      const offerSum = offerAddons.reduce((sum, offer) => {
        const isSelected = (selectedItems[offer.addOnItemId] || []).some(
          (selectedOffer) =>
            selectedOffer.brandOfferItemDTO.id ===
            offer.offer.brandOfferItemDTO.id
        );
        return isSelected ? sum + offer.offerAmount : sum;
      }, 0);

      return total + offerSum;
    }, 0);
  };

  // const calculateGSTAmount = taxableAmount => gst * taxableAmount;
  const calculateGSTAmount = (taxableAmount) => {
    // if (storeGstType === "including") {
    //   return additionalInfoIsCheckedGST
    //     ? Math.round(taxableAmount - (taxableAmount * 100) / (100 + gstValue))
    //     : 0;
    // } else {
    return additionalInfoIsCheckedGST ? gst * taxableAmount : 0;
    // }
  };

  const calculateGrandTotal = (taxableAmount, gstAmount) =>
    taxableAmount + gstAmount;

  let taxableAmount = calculateTaxableAmount();
  const amountForSubscription = calculateAmountForSubscription();

  const gstAmount = calculateGSTAmount(taxableAmount);
  // if (storeGstType === "including") {
  // taxableAmount = taxableAmount - gstAmount;
  // }

  const grandTotal = calculateGrandTotal(taxableAmount, gstAmount);

  const [receiveAmount, setReceiveAmount] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);

  const totalGarmentCount = transformedCartData.reduce((sum, item) => {
    return sum + (item.totalItemGarmentCount || 0); // add garmentQrCount or 0 if undefined
  }, 0);

  const [totalPackageCountModalVisible, setTotalPackageCountModalVisible] =
    useState(false);
  const [packagePriceEditModalVisible, setPackagePriceEditModalVisible] =
    useState(false);
  const [selectedPackageItemValue, setSelectedPackageItemValue] =
    useState(null);

  const receiveDataFromTotalPackageCountModal = ({ success }) => {
    if (success) {
      fetchCartDetail();
      fetchDocsSchedule();
      fetchStoreCustomerInfo();
      fetchCartPackage();
      setSelectedPackageItemValue(null);
    }
  };

  const receiveDataFromPackagePriceEditModal = ({ success }) => {
    if (success) {
      fetchCartDetail();
      fetchDocsSchedule();
      fetchStoreCustomerInfo();
      fetchCartPackage();
      setSelectedPackageItemValue(null);
    }
  };

  const receiveDataFromChooseB2BModel = ({ B2BModelEnabled }) => {
    if (B2BModelEnabled) {
      setB2BModelSelected(B2BModelEnabled)
    }
  };

  const handleAddMoreGarment = () => {
    navigate("/BookNewOrder", {
      state: {
        storeCustomerId: storeCustomerId,
      },
    });
  };

  const handleCheckPackageSubscriptionOffer = ({
    selectedItemId,
    selectedItemValue,
  }) => {
    // if (selectedItemId !== checkedPackageSubscriptionOfferId) {
    setCheckedPackageSubscriptionOfferId(selectedItemId);
    setCheckedPackageSubscriptionOfferValue(selectedItemValue);
    // }
  };

  // useEffect(() => {
  //   const requestData = {
  //     statusIn: ["ACTIVE", "RUNNING",],
  //     brandId: brandId,
  //     storeCustomerId: [storeCustomerId],
  //   };

  //   getAllCustomerPackageOffer(brandId, requestData)
  //     .then((response) => {
  //       if (!response.data.error) {
  //         const Res = response.data.filter(
  //           (item) =>
  //             (item.status === "ACTIVE" || item.status === "RUNNING") &&
  //             item.leftDiscount > 0
  //         );

  //         const selectedMatchedSubscription = Res.filter((item) => item.id === checkedPackageSubscriptionOfferId)
  //         const subscriptionAmountValue = selectedMatchedSubscription[0]?.leftServiceValue

  //         if (grandTotal > subscriptionAmountValue && blockCheckoutInPackageSubscriptionLowBalance) {
  //           setSubscriptionCanNotApply(true)
  //           setSubscriptionMessageDisplay(true);
  //           setSubscriptionMessageText(
  //             "Customer Current Subscription Does Not Fully Cover This Order. We Suggest Please Renew Your Subscription."
  //           );
  //         } else {
  //           setSubscriptionCanNotApply(false)
  //           // setSubscriptionCanNotApplyMessage
  //           if (grandTotal > subscriptionAmountValue && checkedPackageSubscriptionOfferId !== null && checkedPackageSubscriptionOfferValue !== null) {
  //             setSubscriptionMessageDisplay(true);
  //             setSubscriptionMessageText(
  //               "Customer Current Subscription Does Not Fully Cover This Order. We Suggest Please Renew Your Subscription."
  //             );
  //           }
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Error:", err);
  //     });

  // }, [blockCheckoutInPackageSubscriptionLowBalance, checkedPackageSubscriptionOfferId, checkedPackageSubscriptionOfferValue, grandTotal])


  useEffect(() => {
    const requestData = {
      statusIn: ["ACTIVE", "RUNNING"],
      brandId,
      storeCustomerId: [storeCustomerId],
    };

    getAllCustomerPackageOffer(brandId, requestData)
      .then((response) => {
        if (response.data.error) {
          return;
        }

        const activeSubscriptions = response.data.filter(
          (item) =>
            (item.status === "ACTIVE" || item.status === "RUNNING") &&
            item.leftDiscount > 0
        );

        const selectedSubscription = activeSubscriptions.find(
          (item) => item.id === checkedPackageSubscriptionOfferId
        );

        const subscriptionAmountValue =
          Number(selectedSubscription?.leftServiceValue) || 0;

        const hasSubscription =
          checkedPackageSubscriptionOfferId !== null &&
          checkedPackageSubscriptionOfferId !== undefined &&
          checkedPackageSubscriptionOfferValue !== null &&
          checkedPackageSubscriptionOfferValue !== undefined;

        const insufficientBalance =
          hasSubscription && grandTotal > subscriptionAmountValue;

        // Reset states first
        setSubscriptionCanNotApply(false);
        setSubscriptionMessageDisplay(false);

        if (!insufficientBalance) {
          return;
        }

        const message =
          "Customer Current Subscription Does Not Fully Cover This Order. We Suggest Please Renew Your Subscription.";

        // Block checkout
        if (blockCheckoutInPackageSubscriptionLowBalance) {
          setSubscriptionCanNotApply(true);
          setSubscriptionMessageDisplay(true);
          setSubscriptionMessageText(message);
          return;
        }

        // Show warning but allow checkout
        setSubscriptionMessageDisplay(true);
        setSubscriptionMessageText(message);
      })
      .catch((err) => {
        console.error("Error:", err);

        // Optional: reset states when API fails
        setSubscriptionCanNotApply(false);
        setSubscriptionMessageDisplay(false);
      });
  }, [
    brandId,
    storeCustomerId,
    grandTotal,
    checkedPackageSubscriptionOfferId,
    checkedPackageSubscriptionOfferValue,
    blockCheckoutInPackageSubscriptionLowBalance,
  ]);


  const renderCardItem = () => {
    return transformedCartData?.map((item, index) => {
      const offerSum = calculateSumOffersForItem(item); // Assuming this calculates the sum for each item
      return (
        <div>
          <div
            className="flex-1 p-3 border-bottom-1 "
            style={{
              borderBottomColor: "#C1C9D3",
            }}
          >
            <div className="flex-row">
              <div>
                <img
                  src={
                    item.garmentLogo
                      ? `data:image/jpeg;base64,${item.garmentLogo}`
                      : "Laundry_app_icons/Tshirt.png"
                  }
                  resizeMode="cover"
                  style={{
                    alignSelf: "center", // to center an image
                    width: height < 600 ? 64 : 74,
                    height: height < 600 ? 64 : 74,
                  }}
                />
                <p className=" text-xl text-center font-medium capitalize ml-2">
                  {storeLocalData?.currencySymbol} {Number(item.garmentTotalPrice?.toFixed(enabledAmountRoundOff))}
                </p>
              </div>
              <div className="flex-1">
                <div className="flex-1 ml-2">
                  <p className=" text-lg font-medium capitalize ml-2">
                    {item.garmentName.replace(/_/g, " ")}
                  </p>
                  <p className=" text-md font-normal ml-2">
                    Category: {item.categoryName} | Total Garment Count:{" "}
                    {item.totalItemGarmentCount}
                  </p>
                  {/*item.addOn?.map((service) => (
                    <p className=" text-md font-normal ml-2" key={service.id}>
                      {service.serviceName} | {service.serviceUnit}
                      {item.bookingType === "GeneralBooking" && (
                        <React.Fragment>
                          {" | "}
                          {service.serviceUnit === "Qty"
                            ? service.count
                            : parseFloat(
                                service.count + service.countGram
                              ).toFixed(2)}{" "}
                          | {storeLocalData?.currencySymbol} {service.totalPrice}
                        </React.Fragment>
                      )}
                    </p>
                  ))*/}
                  {item.cartGarmentList.map((cartGarmentItem) => (
                    <React.Fragment key={cartGarmentItem.id}>
                      {cartGarmentItem.addOn?.map((service) => (
                        <div key={service.id}>
                          <p className="text-md font-normal ml-2">
                            {cartGarmentItem.garmentAlias} {service.serviceName}{" "}
                            | {service.serviceUnit}
                            {cartGarmentItem.bookingType ===
                              "GeneralBooking" && (
                                <>
                                  {" | "}
                                  {service.serviceUnit === "Qty"
                                    ? service.count
                                    : parseFloat(
                                      service.count + service.countGram
                                    ).toFixed(2)}{" "}
                                  | {storeLocalData?.currencySymbol} {Number(service.totalPrice?.toFixed(enabledAmountRoundOff))}
                                </>
                              )}
                          </p>
                          {!b2BModelSelected && cartGarmentItem.offerAddon?.length > 0 && (
                            <div className="my-1">
                              {cartGarmentItem.offerAddon.map(
                                (offer, index) => {
                                  if (
                                    service.serviceName !==
                                    offer.addOnServiceName
                                  )
                                    return null;

                                  return (
                                    <div
                                      className="flex align-items-center"
                                      key={`offer-${offer.id}-${index}`}
                                    >
                                      <img
                                        src={
                                          "Laundy_App_Icons_Gifs/SettingIcons/gift.png"
                                        }
                                        style={{
                                          width: height < 600 ? 20 : 25,
                                          height: height < 600 ? 20 : 25,
                                        }}
                                        alt="Gift"
                                      />
                                      <div
                                        className="flex my-1 mx-1 border-round-md shadow-4"
                                        style={{
                                          borderRadius: 5,
                                          backgroundImage:
                                            "radial-gradient(circle at left top, #2E3192, #ffffff)",
                                          flex: 1,
                                        }}
                                      >
                                        <div className="flex-row flex justify-content-between align-items-center py-1 px-2">
                                          <p className="text-md text-white font-medium capitalize">
                                            {offer.offerName} -{" "}
                                            {offer.addOnServiceName}
                                          </p>
                                          <p className="text-md text-white font-medium capitalize">
                                            {offer.offerCount}
                                          </p>
                                          <p className="text-md text-white font-medium capitalize">
                                            {storeLocalData?.currencySymbol} {offer.offerAmount}
                                          </p>
                                          <Checkbox
                                            onChange={() =>
                                              handleSelectOffer(
                                                offer.addOnItemId,
                                                offer
                                              )
                                            }
                                            checked={(
                                              selectedItems[
                                              offer.addOnItemId
                                              ] || []
                                            ).some(
                                              (selectedOffer) =>
                                                selectedOffer.brandOfferItemDTO
                                                  .id ===
                                                offer.offer.brandOfferItemDTO.id
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          )}
                        </div>
                      ))}

                      {cartGarmentItem.remarks && (
                        <p className="text-lg font-medium capitalize ml-2">
                          Remark: {cartGarmentItem.remarks}
                        </p>
                      )}
                      <div
                        className="my-2 border-top-1"
                        style={{ borderTopColor: "#ddd" }}
                      ></div>
                      <div className="flex flex-row justify-content-end mt-1">
                        <div
                          className="flex px-2 py-1 align-items-center cursor-pointer"
                          style={{
                            backgroundColor: "#FFF3F3",
                            borderRadius: 5,
                            pointerEvents: isCheckOutButtonPressed
                              ? "none"
                              : "auto",
                          }}
                          onClick={() => {
                            handleRemoveFromCart(
                              cartGarmentItem.itemId,
                              cartGarmentItem.addOnId
                            );
                          }}
                        >
                          <img
                            src={"Laundy_App_Icons_Gifs/Other_Icons/Remove.png"}
                            style={{
                              width: 12,
                              height: 12,
                            }}
                          />

                          <p
                            className=" text-md font-normal capitalize ml-2"
                            style={{ color: "red" }}
                          >
                            Remove
                          </p>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}

                  {offerSum > 0 && (
                    <p
                      className=" text-lg font-medium capitalize ml-2"
                      style={{ color: "red" }}
                    >
                      Total Offer Discount: {storeLocalData?.currencySymbol} {offerSum}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  const handlePackageEdit = (itemPackage) => {
    setSelectedPackageItemValue(itemPackage);
    setTotalPackageCountModalVisible(true);

    setSelectedCarryForwardCount((prev) =>
      prev.filter((item) => item.cartPackageId !== itemPackage.id)
    );
  };

  const handlePackagePriceEdit = (itemPackage) => {
    setSelectedPackageItemValue(itemPackage);
    setPackagePriceEditModalVisible(true);

    // setSelectedCarryForwardCount((prev) =>
    //   prev.filter((item) => item.cartPackageId !== itemPackage.id)
    // );
  };

  const handleMarkCarryForwardToggle = (id) => {
    const updatedCarryForward = [...markCarryForwardPackage];

    if (updatedCarryForward.includes(id)) {
      // Remove status if already selected
      updatedCarryForward.splice(updatedCarryForward.indexOf(id), 1);
    } else {
      // Add status if not selected
      updatedCarryForward.push(id);
    }

    setMarkCarryForwardPackage(updatedCarryForward);

    // Also remove any matching entry from selectedCarryForwardCount
    setSelectedCarryForwardCount((prev) =>
      prev.filter((item) => item.cartPackageId !== id)
    );
  };

  const handleCheckLeftCarryForwardPackageCountToggle = (
    cartPackageId,
    carryForwardOrderPackageId
  ) => {
    const isAlreadySelected = selectedCarryForwardCount.some(
      (selected) =>
        selected.cartPackageId === cartPackageId &&
        selected.carryForwardOrderPackageId === carryForwardOrderPackageId
    );

    let updatedSelected = [];

    if (isAlreadySelected) {
      // REMOVE selection
      updatedSelected = selectedCarryForwardCount.filter(
        (selected) =>
          !(
            selected.cartPackageId === cartPackageId &&
            selected.carryForwardOrderPackageId === carryForwardOrderPackageId
          )
      );

      const packageItem = cartPackageData.find(
        (item) => item.id === cartPackageId
      );
      if (packageItem) {
        setUpdatedPackagePriceSum((prev) => prev + packageItem.totalPrice);
      }
    } else {
      // ADD selection
      updatedSelected = [
        ...selectedCarryForwardCount,
        { cartPackageId, carryForwardOrderPackageId },
      ];

      const packageItem = cartPackageData.find(
        (item) => item.id === cartPackageId
      );
      if (packageItem) {
        setUpdatedPackagePriceSum((prev) => prev - packageItem.totalPrice);
      }
    }

    setSelectedCarryForwardCount(updatedSelected);
  };

  // const handleCheckLeftCarryForwardPackageCountToggle = (
  //   cartPackageId,
  //   carryForwardOrderPackageId
  // ) => {
  //   const selectedCarryForwardData = {
  //     cartPackageId,
  //     carryForwardOrderPackageId,
  //   };

  //   const alreadySelected = selectedCarryForwardCount.find(
  //     (item) =>
  //       item.cartPackageId === cartPackageId &&
  //       item.carryForwardOrderPackageId === carryForwardOrderPackageId
  //   );

  //   let updatedSelected = [];

  //   if (!alreadySelected) {
  //     // ✅ Add or replace only for this cartPackageId
  //     updatedSelected = selectedCarryForwardCount.filter(
  //       (item) => item.cartPackageId !== cartPackageId
  //     );
  //     updatedSelected.push(selectedCarryForwardData);
  //   } else {
  //     // ✅ Remove only the specific item
  //     updatedSelected = selectedCarryForwardCount.filter(
  //       (item) =>
  //         !(
  //           item.cartPackageId === cartPackageId &&
  //           item.carryForwardOrderPackageId === carryForwardOrderPackageId
  //         )
  //     );
  //   }

  //   setSelectedCarryForwardCount(updatedSelected);

  //   // Also remove from markCarryForwardPackage if deselected
  //   if (alreadySelected) {
  //     setMarkCarryForwardPackage((prev) =>
  //       prev.includes(cartPackageId)
  //         ? prev.filter((id) => id !== cartPackageId)
  //         : prev
  //     );
  //   }
  // };

  const hasInvalidPackages = cartPackageData?.some((item) => {
    if (item.packageDTO?.serviceUnit === "Qty") return false;

    const totalCount = parseFloat(item.itemCount + item.countGram || 0).toFixed(
      2
    );
    return totalCount === "0.00";
  });

  useEffect(() => {
    const updatedPackageIds = [];

    customerOrderPackageLogAllData.forEach((logItem) => {
      const cartItem = cartPackageData.find(
        (cart) => cart.packageDTO.id === logItem.packageDTO.id
      );

      if (cartItem) {
        const total = parseFloat(
          (
            parseFloat(cartItem.itemCount || 0) +
            parseFloat(cartItem.countGram || 0)
          ).toFixed(2)
        );

        if (total > logItem.carryForwardCount) {
          updatedPackageIds.push(cartItem.id);
        }
      }
    });

    if (storeAutoPackageCarryForward) {
      const AutoPackageCarryForwardList = cartPackageData.map(
        (item) => item.id
      );
      setMarkCarryForwardPackage(AutoPackageCarryForwardList);

      const carryForwardCountList = [];
      let totalAdjustedPrice = 0;

      cartPackageData.forEach((cartItem) => {
        const matchingLogItem = customerOrderPackageLogAllData.find(
          (logItem) => logItem.packageDTO?.id === cartItem.packageDTO?.id
        );

        const totalCount =
          parseFloat(cartItem.itemCount || 0) +
          parseFloat(cartItem.countGram || 0);

        if (
          matchingLogItem &&
          totalCount <= parseFloat(matchingLogItem.carryForwardCount || 0)
        ) {
          carryForwardCountList.push({
            cartPackageId: cartItem.id,
            carryForwardOrderPackageId: matchingLogItem.id,
          });

          // Subtract package price like in the toggle logic
          totalAdjustedPrice -= cartItem.totalPrice;
        }
      });

      setSelectedCarryForwardCount(carryForwardCountList);
      setUpdatedPackagePriceSum(totalAdjustedPrice); // <-- update this state here
    } else {
      setMarkCarryForwardPackage(updatedPackageIds);
      setUpdatedPackagePriceSum(0); // or reset to default if needed
    }
  }, [
    customerOrderPackageLogAllData,
    cartPackageData,
    storeAutoPackageCarryForward,
  ]);

  const renderPackageCardItem = () => {
    return cartPackageData?.map((item, index) => {
      const checkLeftCarryForwardPackageCount =
        customerOrderPackageLogAllData.filter(
          (countItem) => countItem.packageDTO.id === item.packageDTO.id
        );

      const isInvalidPackage =
        item.packageDTO.serviceUnit !== "Qty" &&
        parseFloat(item.itemCount + item.countGram || 0).toFixed(2) === "0.00";

      return (
        <div
          className="border-bottom-1 "
          style={{
            borderBottomColor: "#C1C9D3",
          }}
        >
          <div className="flex flex-1 p-3 ">
            <div>
              <div>
                <img
                  src={
                    item.packageDTO.price.logo
                      ? `data:image/jpeg;base64,${item.packageDTO.price.logo}`
                      : "Laundry_app_icons/Tshirt.png"
                  }
                  resizeMode="cover"
                  style={{
                    alignSelf: "center", // to center an image
                    width: height < 600 ? 64 : 74,
                    height: height < 600 ? 64 : 74,
                  }}
                />
              </div>
              <p className=" text-2xl   font-medium capitalize ml-2">
                {storeLocalData?.currencySymbol} {Number(item.totalPrice?.toFixed(enabledAmountRoundOff))}
              </p>
            </div>
            <div className="flex-1">
              <div className="flex-1 ml-2">
                <p className=" text-lg font-medium capitalize ml-2">
                  {item.packageDTO.name}
                </p>
                <p className="text-md font-normal ml-2">
                  Description: {item?.packageDTO?.description} |{" "}
                  {item?.packageDTO?.serviceUnit}/Package :{" "}
                  {item?.packageDTO?.quantity} | Price/Package:{" "}
                  {storeLocalData?.currencySymbol}{" "}

                  {offerPriceEnabled &&
                    item?.offerPrice != null &&
                    item?.offerPrice !== 0 &&
                    item?.packageDTO?.amount != null &&
                    item?.packageDTO?.amount !== item?.offerPrice ? (
                    <>
                      <span
                        style={{
                          textDecoration: "line-through",
                          color: "red",
                        }}
                      >
                        {Number(item.packageDTO.amount.toFixed(enabledAmountRoundOff))}
                      </span>

                      <span>
                        {" "}
                        {Number(item.offerPrice.toFixed(enabledAmountRoundOff))}
                      </span>
                    </>
                  ) : (
                    <span>
                      {Number((item?.packageDTO?.amount ?? 0).toFixed(enabledAmountRoundOff))}
                    </span>
                  )}
                </p>
                <p></p>
              </div>
              <div className="flex flex-row justify-content-between ml-2">
                <div>
                  <p
                    className=" text-lg font-bold ml-2"
                    style={{ color: "#2B70D7" }}
                  >
                    Pkg Count: {item.packageCount}
                  </p>
                </div>
                <div>
                  <p
                    className=" text-lg font-bold ml-2"
                    style={{ color: "#2B70D7" }}
                  >
                    Total {item.packageDTO.serviceUnit}:{" "}
                    {item.packageDTO.serviceUnit === "Qty"
                      ? item.itemCount
                      : parseFloat(item.itemCount + item.countGram).toFixed(2)}
                  </p>
                </div>
              </div>
              <div className="flex flex-row justify-content-between ml-2">
                <div className="flex flex-row justify-content-between ml-2">
                  {isInvalidPackage ? (
                    <div style={{ marginTop: 5 }}>
                      <p style={{ color: "red", fontSize: 12 }}>
                        Please enter a valid package value
                      </p>
                    </div>
                  ) : <div></div>}
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", gap: 10, }}>
                    {offerPriceEnabled && !item.packageDTO.carryForward && item.packageDTO.serviceUnit === "Qty" && <div className="flex flex-row justify-content-end mt-1">
                      <div
                        className="flex px-2 py-1 align-items-center cursor-pointer"
                        style={{
                          backgroundColor: "#b4f7b2",
                          borderRadius: 5,
                          pointerEvents: isCheckOutButtonPressed
                            ? "none"
                            : "auto",
                        }}
                        onClick={() => {
                          handlePackagePriceEdit(item);
                        }}
                      >
                        <p
                          className=" text-md font-normal capitalize mx-1"
                          style={{ color: "Green" }}
                        >
                          Price
                        </p>
                        <i
                          className="pi pi-pencil"
                          style={{
                            fontSize: "12px",
                            cursor: "pointer",
                            color: "green",
                          }}
                        ></i>
                      </div>
                    </div>}
                    {item.packageDTO.serviceUnit !== "Qty" && (
                      <div className="flex flex-row justify-content-end mt-1">
                        <div
                          className="flex px-2 py-1 align-items-center cursor-pointer"
                          style={{
                            backgroundColor: "#FFF3F3",
                            borderRadius: 5,
                            pointerEvents: isCheckOutButtonPressed
                              ? "none"
                              : "auto",
                          }}
                          onClick={() => {
                            handlePackageEdit(item);
                          }}
                        >
                          <p
                            className=" text-md font-normal capitalize mx-1"
                            style={{ color: "red" }}
                          >
                            Edit
                          </p>
                          <i
                            className="pi pi-pencil"
                            style={{
                              fontSize: "12px",
                              cursor: "pointer",
                              color: "red",
                            }}
                          ></i>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: 10,
                }}
              >
                {brandCarryForward &&
                  storeCarryForward &&
                  item.packageDTO.carryForward ? (
                  checkLeftCarryForwardPackageCount.length > 0 ? (
                    checkLeftCarryForwardPackageCount?.map(
                      (carryForwardItem, index) => {
                        if (
                          parseFloat(item.itemCount + item.countGram).toFixed(
                            2
                          ) > carryForwardItem.carryForwardCount
                        )
                          return (
                            <div className="flex flex-row  ml-2">
                              <div
                                className="px-2 py-1 border-round-md"
                                style={{
                                  backgroundColor:
                                    markCarryForwardPackage.includes(item.id)
                                      ? "#b4f7b2"
                                      : "#FFF3F3",
                                }}
                              >
                                <p
                                  style={{
                                    color: markCarryForwardPackage.includes(
                                      item.id
                                    )
                                      ? "#0d9109"
                                      : "#FF5353",
                                  }}
                                >
                                  Carry Forward{" "}
                                  {"(" +
                                    parseFloat(
                                      item.packageDTO.quantity *
                                      item.packageCount -
                                      parseFloat(
                                        item.itemCount + item.countGram
                                      ).toFixed(2)
                                    ).toFixed(2) +
                                    " " +
                                    item.packageDTO.serviceUnit +
                                    " Left)"}
                                </p>
                              </div>
                              <div className="flex  justify-content-center align-items-center ml-2">
                                <div>
                                  <Checkbox
                                    checked={markCarryForwardPackage.includes(
                                      item.id
                                    )}
                                    color={
                                      markCarryForwardPackage.includes(item.id)
                                        ? "#00A3FF"
                                        : "#C1C9D3"
                                    }
                                    onClick={() =>
                                      handleMarkCarryForwardToggle(item.id)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          );
                      }
                    )
                  ) : (
                    <div className="flex flex-row  ml-2">
                      <div
                        className="px-2 py-1 border-round-md"
                        style={{
                          backgroundColor: markCarryForwardPackage.includes(
                            item.id
                          )
                            ? "#b4f7b2"
                            : "#FFF3F3",
                        }}
                      >
                        <p
                          style={{
                            color: markCarryForwardPackage.includes(item.id)
                              ? "#0d9109"
                              : "#FF5353",
                          }}
                        >
                          Carry Forward{" "}
                          {"(" +
                            parseFloat(
                              item.packageDTO.quantity * item.packageCount -
                              parseFloat(
                                item.itemCount + item.countGram
                              ).toFixed(2)
                            ).toFixed(2) +
                            " " +
                            item.packageDTO.serviceUnit +
                            " Left)"}
                        </p>
                      </div>
                      <div className="flex  justify-content-center align-items-center ml-2">
                        <div>
                          <Checkbox
                            checked={markCarryForwardPackage.includes(item.id)}
                            color={
                              markCarryForwardPackage.includes(item.id)
                                ? "#00A3FF"
                                : "#C1C9D3"
                            }
                            onClick={() =>
                              handleMarkCarryForwardToggle(item.id)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div></div>
                )}
              </div>
              <div>
                {checkLeftCarryForwardPackageCount?.map(
                  (carryForwardItem, index) => {
                    if (
                      parseFloat(item.itemCount + item.countGram).toFixed(2) >
                      carryForwardItem.carryForwardCount
                    )
                      return null;

                    return (
                      <div
                        key={`carryForwardItem-${carryForwardItem.id}-${index}`}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <div
                            className="flex my-1 mx-1 border-round-md shadow-4"
                            style={{
                              borderRadius: 5,
                              backgroundImage:
                                "radial-gradient(circle at left top, #2E3192, #ffffff)",
                              flex: 1,
                            }}
                          >
                            <div className="flex-row flex justify-content-between align-items-center py-1 px-2">
                              <p className="text-md text-white font-medium capitalize">
                                Left Package Count{" "}
                                {parseFloat(
                                  carryForwardItem.carryForwardCount
                                ).toFixed(2)}{" "}
                                {item.packageDTO.serviceUnit}
                              </p>
                              <Checkbox
                                checked={selectedCarryForwardCount.some(
                                  (selected) =>
                                    selected.cartPackageId === item.id &&
                                    selected.carryForwardOrderPackageId ===
                                    carryForwardItem.id
                                )}
                                color={
                                  selectedCarryForwardCount.some(
                                    (selected) =>
                                      selected.cartPackageId === item.id &&
                                      selected.carryForwardOrderPackageId ===
                                      carryForwardItem.id
                                  )
                                    ? "#00A3FF"
                                    : "#C1C9D3"
                                }
                                onChange={() =>
                                  handleCheckLeftCarryForwardPackageCountToggle(
                                    item.id,
                                    carryForwardItem.id
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div>
      );
    });
  };


  // const localISO =
  //   additionalInfoDeliveryDate.getFullYear() + "-" +
  //   String(additionalInfoDeliveryDate.getMonth() + 1).padStart(2, "0") + "-" +
  //   String(additionalInfoDeliveryDate.getDate()).padStart(2, "0") + "T" +
  //   String(additionalInfoDeliveryDate.getHours()).padStart(2, "0") + ":" +
  //   String(additionalInfoDeliveryDate.getMinutes()).padStart(2, "0") + ":" +
  //   String(additionalInfoDeliveryDate.getSeconds()).padStart(2, "0");


  const handleConfirmAndContinue = async () => {
    // Check if the button has already been pressed
    if (!isCheckOutButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsCheckOutButtonPressed(true);

      // const sendLocalDateTimeAsUTC = () => {
      //   const now = additionalInfoDeliveryDate;
      //   const offset = now.getTimezoneOffset(); // Offset in minutes
      //   const adjustedDate = new Date(now.getTime() - (offset * 60 * 1000) + 1000);
      //   return adjustedDate.toISOString(); // Local time in UTC format
      // };

      // // Usage
      // const currentDateTime = sendLocalDateTimeAsUTC();

      // main code below

      // const currentTime = new Date();
      // additionalInfoDeliveryDate?.setHours(
      //   currentTime.getHours(),
      //   currentTime.getMinutes(),
      //   currentTime.getSeconds(),
      //   currentTime.getMilliseconds()
      // );

      // const newDate = new Date(additionalInfoDeliveryDate);
      // const currentDateTime = newDate.toISOString();



      // additionalInfoDeliveryDate?.setUTCHours(0, 0, 0, 0);
      // const currentDateTime = additionalInfoDeliveryDate.toISOString();


      // new code 

      // const currentDateTime =
      //   additionalInfoDeliveryDate.getFullYear() + "-" +
      //   String(additionalInfoDeliveryDate.getMonth() + 1).padStart(2, "0") + "-" +
      //   String(additionalInfoDeliveryDate.getDate()).padStart(2, "0") + "T" +
      //   String(additionalInfoDeliveryDate.getHours()).padStart(2, "0") + ":" +
      //   String(additionalInfoDeliveryDate.getMinutes()).padStart(2, "0") + ":" +
      //   String(additionalInfoDeliveryDate.getSeconds()).padStart(2, "0") + ".000";

      const currentDateTime =
        additionalInfoDeliveryDate.getFullYear() + "-" +
        String(additionalInfoDeliveryDate.getMonth() + 1).padStart(2, "0") + "-" +
        String(additionalInfoDeliveryDate.getDate()).padStart(2, "0") + "T05:36:00.000Z";

      const orderData = {
        storeUserId: storeUserId,
        storeCustomerId: storeCustomerId,
        totalQuantity: 1,
        totalAmount: Number(totalAmountSum?.toFixed(enabledAmountRoundOff)),
        gstType: storeGstType,
        gstPercent: gstValue === null ? 0 : gstValue,
        taxableAmount: Number(taxableAmount?.toFixed(enabledAmountRoundOff)),
        gstAmount: Number(gstAmount?.toFixed(enabledAmountRoundOff)),
        discountAmount: Number(additionalDiscountData?.toFixed(enabledAmountRoundOff)),
        chargeAmount: Number(additionalChargesData?.toFixed(enabledAmountRoundOff)),
        grandTotal: Number(grandTotal?.toFixed(enabledAmountRoundOff)),
        deliveryOn: currentDateTime,
        orderChargeDiscount: b2BModelSelected ? [] : selectedChargesDiscountArray,
        deliveryRequest: additionalInfoIsCheckedHomeDelivery,
        urgentDelivery: additionalInfoIsCheckedUrgentDelivery,
        orderSource: userRole !== null ? userRole : "",
        bookedByUserName: userProfileData?.firstName + userProfileData?.lastName,
        docsScheduled:
          userRole === "BY_STORE"
            ? additionalInfoIsDocsScheduleValue === true
              ? "yes"
              : "no"
            : "yes",
        remarks: additionalInfoOtherRemarkValue,
        offerDiscount: offerDiscountSum,
        // offers: {cartAddOnOfferMapList: selectedItems},
        offers: {
          cartAddOnOfferMapList: Object.fromEntries(
            Object.entries(selectedItems).map(([key, value]) => [
              key,
              value.map(({ addOnServiceName, ...rest }) => rest),
            ])
          ),
        },
        paymentDTO: {
          receivedBy: storeUserId,
          paidBy: storeCustomerId,
          amount: receiveAmount > 0 ? receiveAmount : 0,
          paymentMode: paymentMethod === "" ? null : paymentMethod,
        },
        subscriptionDiscount:
          checkedPackageSubscriptionOfferValue === null
            ? 0
            : checkedPackageSubscriptionOfferValue,
        appliedSubscriptionDiscount:
          checkedPackageSubscriptionOfferValue > 0 ? true : false,
        autoApplySubscriptionWithPackage: checkedPackageSubscriptionOfferValue > 0 ? true : false,
      };

      if (userRole === 'BY_STORE') {
        await setSelectedDocsSchedule(
          additionalInfoIsDocsScheduleValue === true ? "yes" : "no"
        );
      }

      const markCarryForwardData = { cartPackageIdIn: markCarryForwardPackage };

      if (brandCarryForward && storeCarryForward) {
        if (selectedCarryForwardCount.length > 0) {
          const selectedCarryForwardCountList = {
            list: selectedCarryForwardCount,
          };
          CartPackageCarryForwardApply(
            storeId,
            storeCustomerId,
            selectedCarryForwardCountList
          )
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res.status) {
                  if (checkedPackageSubscriptionOfferId !== null) {
                    setPackageSubscriptionOfferDefault(
                      brandId,
                      storeId,
                      checkedPackageSubscriptionOfferId
                    )
                      .then((response) => {
                        if (!response.data.error) {
                          const Res = response.data;
                          if (Res.status) {
                            bookOrder(storeCustomerId, storeId, orderData)
                              .then((response) => {
                                if (!response.data.error) {
                                  const Res = response.data;
                                  setModalVisible(true);
                                  setApiResStatus(Res.status);
                                  if (Res.status) {
                                    const timer = setTimeout(() => {
                                      navigate("/OrdersGarmentInfo", {
                                        state: {
                                          bookingOrderId: Res.orderId,
                                          storeCustomerId: storeCustomerId,
                                          callThrough: "CartPage",
                                        },
                                      });
                                    }, 1200);
                                    return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                                  }
                                }
                              })
                              .catch((err) => {
                                console.error("Error:", err);
                              });
                          }
                        }
                      })
                      .catch((err) => {
                        console.error("Error:", err);
                      });
                  } else {
                    bookOrder(storeCustomerId, storeId, orderData)
                      .then((response) => {
                        if (!response.data.error) {
                          const Res = response.data;
                          setModalVisible(true);
                          setApiResStatus(Res.status);
                          if (Res.status) {
                            const timer = setTimeout(() => {
                              navigate("/OrdersGarmentInfo", {
                                state: {
                                  bookingOrderId: Res.orderId,
                                  storeCustomerId: storeCustomerId,
                                  callThrough: "CartPage",
                                },
                              });
                            }, 1200);
                            return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                          }
                        }
                      })
                      .catch((err) => {
                        console.error("Error:", err);
                      });
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          if (markCarryForwardPackage.length > 0) {
            markCarryForward(storeCustomerId, storeId, markCarryForwardData)
              .then((response) => {
                if (!response.data.error) {
                  const Res = response.data;
                  if (Res.status) {
                    if (checkedPackageSubscriptionOfferId !== null) {
                      setPackageSubscriptionOfferDefault(
                        brandId,
                        storeId,
                        checkedPackageSubscriptionOfferId
                      )
                        .then((response) => {
                          if (!response.data.error) {
                            const Res = response.data;
                            if (Res.status) {
                              bookOrder(storeCustomerId, storeId, orderData)
                                .then((response) => {
                                  if (!response.data.error) {
                                    const Res = response.data;
                                    setModalVisible(true);
                                    setApiResStatus(Res.status);
                                    if (Res.status) {
                                      const timer = setTimeout(() => {
                                        navigate("/OrdersGarmentInfo", {
                                          state: {
                                            bookingOrderId: Res.orderId,
                                            storeCustomerId: storeCustomerId,
                                            callThrough: "CartPage",
                                          },
                                        });
                                      }, 1200);
                                      return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                                    }
                                  }
                                })
                                .catch((err) => {
                                  console.error("Error:", err);
                                });
                            }
                          }
                        })
                        .catch((err) => {
                          console.error("Error:", err);
                        });
                    } else {
                      bookOrder(storeCustomerId, storeId, orderData)
                        .then((response) => {
                          if (!response.data.error) {
                            const Res = response.data;
                            setModalVisible(true);
                            setApiResStatus(Res.status);
                            if (Res.status) {
                              const timer = setTimeout(() => {
                                navigate("/OrdersGarmentInfo", {
                                  state: {
                                    bookingOrderId: Res.orderId,
                                    storeCustomerId: storeCustomerId,
                                    callThrough: "CartPage",
                                  },
                                });
                              }, 1200);
                              return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                            }
                          }
                        })
                        .catch((err) => {
                          console.error("Error:", err);
                        });
                    }
                  } else {
                    if (checkedPackageSubscriptionOfferId !== null) {
                      setPackageSubscriptionOfferDefault(
                        brandId,
                        storeId,
                        checkedPackageSubscriptionOfferId
                      )
                        .then((response) => {
                          if (!response.data.error) {
                            const Res = response.data;
                            if (Res.status) {
                              bookOrder(storeCustomerId, storeId, orderData)
                                .then((response) => {
                                  if (!response.data.error) {
                                    const Res = response.data;
                                    setModalVisible(true);
                                    setApiResStatus(Res.status);
                                    if (Res.status) {
                                      const timer = setTimeout(() => {
                                        navigate("/OrdersGarmentInfo", {
                                          state: {
                                            bookingOrderId: Res.orderId,
                                            storeCustomerId: storeCustomerId,
                                            callThrough: "CartPage",
                                          },
                                        });
                                      }, 1200);
                                      return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                                    }
                                  }
                                })
                                .catch((err) => {
                                  console.error("Error:", err);
                                });
                            }
                          }
                        })
                        .catch((err) => {
                          console.error("Error:", err);
                        });
                    } else {
                      bookOrder(storeCustomerId, storeId, orderData)
                        .then((response) => {
                          if (!response.data.error) {
                            const Res = response.data;
                            setModalVisible(true);
                            setApiResStatus(Res.status);
                            if (Res.status) {
                              const timer = setTimeout(() => {
                                navigate("/OrdersGarmentInfo", {
                                  state: {
                                    bookingOrderId: Res.orderId,
                                    storeCustomerId: storeCustomerId,
                                    callThrough: "CartPage",
                                  },
                                });
                              }, 1200);
                              return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                            }
                          }
                        })
                        .catch((err) => {
                          console.error("Error:", err);
                        });
                    }
                  }
                }
              })
              .catch((err) => {
                console.error("Error:", err);
              });
          }
          else {
            if (checkedPackageSubscriptionOfferId !== null) {
              setPackageSubscriptionOfferDefault(
                brandId,
                storeId,
                checkedPackageSubscriptionOfferId
              )
                .then((response) => {
                  if (!response.data.error) {
                    const Res = response.data;
                    if (Res.status) {
                      bookOrder(storeCustomerId, storeId, orderData)
                        .then((response) => {
                          if (!response.data.error) {
                            const Res = response.data;
                            setModalVisible(true);
                            setApiResStatus(Res.status);
                            if (Res.status) {
                              const timer = setTimeout(() => {
                                navigate("/OrdersGarmentInfo", {
                                  state: {
                                    bookingOrderId: Res.orderId,
                                    storeCustomerId: storeCustomerId,
                                    callThrough: "CartPage",
                                  },
                                });
                              }, 1200);
                              return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                            }
                          }
                        })
                        .catch((err) => {
                          console.error("Error:", err);
                        });
                    }
                  }
                })
                .catch((err) => {
                  console.error("Error:", err);
                });
            } else {
              bookOrder(storeCustomerId, storeId, orderData)
                .then((response) => {
                  if (!response.data.error) {
                    const Res = response.data;
                    setModalVisible(true);
                    setApiResStatus(Res.status);
                    if (Res.status) {
                      const timer = setTimeout(() => {
                        navigate("/OrdersGarmentInfo", {
                          state: {
                            bookingOrderId: Res.orderId,
                            storeCustomerId: storeCustomerId,
                            callThrough: "CartPage",
                          },
                        });
                      }, 1200);
                      return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                    }
                  }
                })
                .catch((err) => {
                  console.error("Error:", err);
                });
            }
          }
        }
      } else {
        if (checkedPackageSubscriptionOfferId !== null) {
          setPackageSubscriptionOfferDefault(
            brandId,
            storeId,
            checkedPackageSubscriptionOfferId
          )
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res.status) {
                  bookOrder(storeCustomerId, storeId, orderData)
                    .then((response) => {
                      if (!response.data.error) {
                        const Res = response.data;
                        setModalVisible(true);
                        setApiResStatus(Res.status);
                        if (Res.status) {
                          const timer = setTimeout(() => {
                            navigate("/OrdersGarmentInfo", {
                              state: {
                                bookingOrderId: Res.orderId,
                                storeCustomerId: storeCustomerId,
                                callThrough: "CartPage",
                              },
                            });
                          }, 1200);
                          return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                        }
                      }
                    })
                    .catch((err) => {
                      console.error("Error:", err);
                    });
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          bookOrder(storeCustomerId, storeId, orderData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                setModalVisible(true);
                setApiResStatus(Res.status);
                if (Res.status) {
                  const timer = setTimeout(() => {
                    navigate("/OrdersGarmentInfo", {
                      state: {
                        bookingOrderId: Res.orderId,
                        storeCustomerId: storeCustomerId,
                        callThrough: "CartPage",
                      },
                    });
                  }, 1200);
                  return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    }
  };

  const handleB2BModelSubmit = async () => {

    const currentDateTime =
      additionalInfoDeliveryDate.getFullYear() + "-" +
      String(additionalInfoDeliveryDate.getMonth() + 1).padStart(2, "0") + "-" +
      String(additionalInfoDeliveryDate.getDate()).padStart(2, "0") + "T05:36:00.000Z";

    const orderData = {
      storeUserId: storeUserId,
      storeCustomerId: storeCustomerId,
      totalQuantity: 1,
      totalAmount: Number(totalAmountSum?.toFixed(enabledAmountRoundOff)),
      gstType: storeGstType,
      gstPercent: gstValue === null ? 0 : gstValue,
      taxableAmount: Number(taxableAmount?.toFixed(enabledAmountRoundOff)),
      gstAmount: Number(gstAmount?.toFixed(enabledAmountRoundOff)),
      discountAmount: 0,
      chargeAmount: 0,
      grandTotal: Number(grandTotal?.toFixed(enabledAmountRoundOff)),
      deliveryOn: currentDateTime,
      orderChargeDiscount: [],
      deliveryRequest: false,
      urgentDelivery: false,
      orderSource: userRole !== null ? userRole : "",
      bookedByUserName: userProfileData?.firstName + userProfileData?.lastName,
      docsScheduled:
        userRole === "BY_STORE"
          ? additionalInfoIsDocsScheduleValue === true
            ? "yes"
            : "no"
          : "yes",
      remarks: additionalInfoOtherRemarkValue,
      offerDiscount: 0,
      offers: {
        cartAddOnOfferMapList: {}
      },
      paymentDTO: {
        receivedBy: storeUserId,
        paidBy: storeCustomerId,
        amount: receiveAmount > 0 ? receiveAmount : 0,
        paymentMode: paymentMethod === "" ? null : paymentMethod,
      },
      subscriptionDiscount: 0,
      appliedSubscriptionDiscount: false,
      autoApplySubscriptionWithPackage: false,
    };

    bookOrderB2BModal(storeCustomerId, storeId, orderData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setModalVisible(true);
          setApiResStatus(Res.status);
          if (Res.status) {
            const timer = setTimeout(() => {
              navigate("/B2BOrdersGarmentInfo", {
                state: {
                  bookingOrderId: Res.orderId,
                  storeCustomerId: storeCustomerId,
                  callThrough: "CartPage",
                },
              });
            }, 1200);
            return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                My Cart
              </p>
            </div>

            <div className="flex justify-content-center align-items-center mr-6">
              <div
                className="active-package-button flex-1 cursor-pointer"
                onClick={() => setCustomerPackagesModalVisible(true)}
              >
                <span className="shine" />
                Active Packages
              </div>
            </div>
            {userRole === "BY_STORE" && (
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                style={{
                  pointerEvents: isCheckOutButtonPressed ? "none" : "auto",
                }}
                onClick={() => navigate("/SearchCustomer")}
              >
                <p className=" text-md text-white font-normal capitalize">
                  New Customer Order
                </p>
              </div>
            )}
            <div className="flex justify-content-center align-items-center">
              <div className="golden-button-delivery-date flex-1">
                <span className="shine" />
                Delivery Date -{" "}
                {new Date(additionalInfoDeliveryDate).toLocaleDateString(
                  "en-GB",
                  {
                    day: "numeric",
                    month: "short",
                    weekday: "short",
                  }
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="flex flex-1 px-3 py-2"
        style={{
          backgroundColor: "#F6FAFF",
        }}
      >
        <div className="flex-row justify-content-center align-items-center">
          <img
            src={"Laundy_App_Icons_Gifs/Other_Icons/Customer.png"}
            style={{
              color: "#75879B",
              height: height < 600 ? 30 : 36,
              width: height < 600 ? 30 : 36,
              alignSelf: "center",
            }}
          />
          <div className="px-2 flex-row">
            <p
              className=" text-xl font-medium capitalize ml-2"
              style={{
                color: "#75879B",
              }}
            >
              Customer :{" "}
            </p>
            <p className=" text-xl font-medium capitalize ml-2">
              {CustomerInformation.firstName} {CustomerInformation.lastName}
              {" | "}
              {maskMobileNumber(CustomerInformation.mobile)}
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-1">
        <div className="flex-1">
          <div>
            {transformedCartData.length !== 0 ? (
              renderCardItem()
            ) : (
              <div className="flex justify-content-center align-items-center">
                <img
                  src={"images/emptyCart.png"}
                  style={{
                    width: height < 600 ? 180 : 200,
                    height: height < 600 ? 180 : 200,
                  }}
                />
              </div>
            )}
          </div>
          <div
            style={{
              backgroundColor: "#fff",
              borderTopWidth: 0.5,
              borderTopColor: "#000",
            }}
          >
            {renderPackageCardItem()}
          </div>
          <div
            className="flex flex-row justify-content-between align-items-center px-4 py-2"
            style={{
              backgroundColor: "#F6FAFF",
            }}
          >
            {transformedCartData.length !== 0 ? (
              <div className="flex flex-row justify-content-start mt-1">
                <div
                  className="flex px-2 py-1 align-items-center cursor-pointer"
                  style={{
                    backgroundColor: "#FFF3F3",
                    borderRadius: 5,
                    pointerEvents: isCheckOutButtonPressed ? "none" : "auto",
                  }}
                  onClick={() => handleRemoveAllItemFromCart()}
                >
                  <img
                    src={"Laundy_App_Icons_Gifs/Other_Icons/Remove.png"}
                    resizeMode="cover"
                    style={{
                      alignSelf: "center", // to center an image
                      width: 12,
                      height: 12,
                    }}
                  />

                  <p
                    className=" text-md font-normal capitalize mx-1"
                    style={{ color: "red" }}
                  >
                    Clear Cart
                  </p>
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="flex flex-column ">
              <div className="flex flex-row">
                <p
                  className=" text-lg font-medium capitalize mx-1"
                  style={{ color: "#75879B" }}
                >
                  Total Garment:{" "}
                </p>
                <p className=" text-lg font-medium capitalize mx-1">
                  {totalGarmentCount}
                </p>
              </div>
              <div className="flex flex-row">
                <p
                  className=" text-lg font-medium capitalize mx-1"
                  style={{ color: "#75879B" }}
                >
                  Total Amount:{" "}
                </p>
                <p className=" text-lg font-medium capitalize mx-1">
                  {storeLocalData?.currencySymbol} {Number(totalAmountSum?.toFixed(enabledAmountRoundOff))}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1">
          <div
            style={{
              pointerEvents: isCheckOutButtonPressed ? "none" : "auto",
            }}
          >
            {/*Additional Info component */}
            <AdditionalInfo
              storeId={storeId}
              processTime={processTime}
              sendDataToCartPage={receiveDataFromAdditionalInfo}
              totalPriceSum={totalAmountSum}
              userRole={userRole}
              taxableAmount={taxableAmount}
              totalGarmentCount={totalGarmentCount}
              offerDiscountSum={offerDiscountSum}
              removalChargeAndDiscountFunction={
                removalChargeAndDiscountFunction
              }
              enabledCustomDiscountCharge={enabledCustomDiscountCharge}
              enabledChargeDiscountByService={enabledChargeDiscountByService}
              storeGstNumber={storeGstNumber}
              autoChargeId={customerData.autoChargeId}
              autoDiscountId={customerData.autoDiscountId}
              uniqueServices={uniqueServices}
              enabledStoreLoad={enabledStoreLoad}
              docsScheduleValue={docsScheduleValue}
              b2BModelSelected={b2BModelSelected}
              enabledGSTControl={enabledGSTControl}
              enabledAmountRoundOff={enabledAmountRoundOff}
              deliveryDateCutoffTime={deliveryDateCutoffTime}
            />
            <PaymentDetail
              taxableAmount={taxableAmount}
              totalPriceSum={totalAmountSum}
              grandTotal={grandTotal}
              gstAmount={gstAmount}
              gst={gst}
              additionalChargesData={additionalChargesData}
              additionalDiscountData={additionalDiscountData}
              additionalInfoIsCheckedGST={additionalInfoIsCheckedGST}
              offerDiscountSum={offerDiscountSum}
              checkedPackageSubscriptionOfferValue={
                checkedPackageSubscriptionOfferValue
              }
              enabledAmountRoundOff={enabledAmountRoundOff}
            />
            {receiveAmount === "" && (paymentMethod === "" || paymentMethod === null)
              //  && !b2BModelSelected 
              && (
                <PackageSubscriptionOfferDefault
                  storeCustomerId={storeCustomerId}
                  storeId={storeId}
                  storeUserId={storeUserId}
                  // grandTotal={Math.round(taxableAmount)}
                  grandTotal={Number(amountForSubscription?.toFixed(enabledAmountRoundOff))}
                  onChecked={handleCheckPackageSubscriptionOffer}
                  enabledApplySubscriptionWithPackage={enabledApplySubscriptionWithPackage}
                  enabledAutoApplySubscriptionWithPackage={enabledAutoApplySubscriptionWithPackage}
                  cartPackageData={cartPackageData}
                  enabledAmountRoundOff={enabledAmountRoundOff}
                  b2BModelSelected={b2BModelSelected}
                  blockCheckoutInPackageSubscriptionLowBalance={blockCheckoutInPackageSubscriptionLowBalance}
                />
              )}
            {checkedPackageSubscriptionOfferId === null &&
              totalAmountSum > 0 && !b2BModelSelected && (
                <AdvancePaymentCollection
                  storeCustomerId={storeCustomerId}
                  storeId={storeId}
                  storeUserId={storeUserId}
                  grandTotal={Number(grandTotal?.toFixed(enabledAmountRoundOff))}
                  onSubmit={handleAdvancePaymentSubmit}
                  enabledAmountRoundOff={enabledAmountRoundOff}
                />
              )}
          </div>
          <div className="flex justify-content-center align-items-center">
            <img
              src={"VectorsLaundryApp/5.png"}
              style={{
                alignSelf: "center",
                marginTop: 20,
              }}
            />
          </div>
        </div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={apiResStatus === true ? "success" : false}
          text={
            apiResStatus === true
              ? "Your order is booked successfully! check order’s status, details etc. in customer’s detail section!"
              : "Your order is booking is failed! Please try again later"
          }
        />
        <OfferMessageModal
          setModalVisible={setMessageDisplay}
          modalVisible={messageDisplay}
          messageText={messageText}
        />
        <SubscriptionMessageModal
          setSubscriptionMessageModalVisible={setSubscriptionMessageDisplay}
          subscriptionMessageModalVisible={subscriptionMessageDisplay}
          messageText={subscriptionMessageText}
        />

        <TotalPackageCountModal
          setTotalPackageCountModalVisible={setTotalPackageCountModalVisible}
          totalPackageCountModalVisible={totalPackageCountModalVisible}
          sendDataToTotalPackageCountModal={
            receiveDataFromTotalPackageCountModal
          }
          storeId={storeId}
          storeCustomerId={storeCustomerId}
          selectedPackageItemValue={selectedPackageItemValue}
          offerPriceEnabled={offerPriceEnabled}
        />

        <PackagePriceEditModal
          setPackagePriceEditModalVisible={setPackagePriceEditModalVisible}
          packagePriceEditModalVisible={packagePriceEditModalVisible}
          sendDataToPackagePriceEditModal={
            receiveDataFromPackagePriceEditModal
          }
          storeId={storeId}
          storeCustomerId={storeCustomerId}
          selectedPackageItemValue={selectedPackageItemValue}
        />
        {customerPackagesModalVisible && (
          <CustomerPackagesModal
            customerPackagesModalVisible={customerPackagesModalVisible}
            setCustomerPackagesModalVisible={setCustomerPackagesModalVisible}
            storeId={storeId}
            storeCustomerId={storeCustomerId}
            brandId={brandId}
            // storeLoadData={storeLoadData}
            brandCarryForwardApplyOn={brandCarryForwardApplyOn}
          />
        )}
        {chooseB2BModelVisible && (
          <ChooseB2BModal
            chooseB2BModelVisible={chooseB2BModelVisible}
            setChooseB2BModelVisible={setChooseB2BModelVisible}
            sendDataToChooseB2BModel={receiveDataFromChooseB2BModel}
          />
        )}
      </div>

      <div className="relative mt-8">
        <div
          className="flex flex-1 flex-row gap-5 px-4 py-2 fixed w-full z-2 bottom-0"
          style={{ backgroundColor: "white" }}
        >
          <div className="flex-1">
            <Button
              label="ADD More Garment"
              onClick={() => handleAddMoreGarment()}
              disabled={isCheckOutButtonPressed}
              className=" text-xl w-full border-round-xl  cursor-pointer"
              style={{
                color: "#2B70D7",
                backgroundColor: "#fff",
                borderColor: "#2B70D7",
              }}
            ></Button>
          </div>
          <div className="flex-1">
            {
              !b2BModelSelected ?
                subscriptionCanNotApply ?
                  <Button
                    label={"Subscription Can Not Apply"}
                    disabled={true}
                    className=" text-xl w-full border-round-xl border-none cursor-pointer"
                  ></Button>
                  :
                  <Button
                    label={isCheckOutButtonPressed ? "Loading..." : "Check Out"}
                    onClick={() => handleConfirmAndContinue()}
                    disabled={
                      totalAmountSum < 0
                        ? true
                        : totalAmountSum <= 0 && totalGarmentCount <= 0
                          ? true
                          : collectAdvancePaymentCheck === true
                            ? true
                            : isCheckOutButtonPressed === true
                              ? true
                              : hasInvalidPackages
                    }
                    className=" text-xl w-full border-round-xl border-none cursor-pointer"
                  ></Button>
                :
                <Button
                  label={isCheckOutButtonPressed ? "Loading..." : "Check Out B2B"}
                  onClick={() => handleB2BModelSubmit()}
                  disabled={
                    totalAmountSum < 0
                      ? true
                      : totalAmountSum <= 0 && totalGarmentCount <= 0
                        ? true
                        : collectAdvancePaymentCheck === true
                          ? true
                          : isCheckOutButtonPressed === true
                            ? true
                            : hasInvalidPackages
                  }
                  className=" text-xl w-full border-round-xl border-none cursor-pointer"
                ></Button>
            }
            {/* <FullScreenBtn
            bgColor={
              totalAmountSum <= 0 ||
              isCheckOutButtonPressed ||
              collectAdvancePaymentCheck === true
                ? disabledColor
                : blueColor
            }
            bdColor={blueColor}
            textColor={whiteColor}
            btnLabel={isCheckOutButtonPressed ? 'Loading...' : 'Check Out'}
            press={() => handleConfirmAndContinue()}
             
          /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
